import { FC, Fragment } from 'react'

import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import { ComplexRouteHeaderViewModel } from '../lib/prepare-complex-route-header-data'

import s from './styles.module.scss'

interface Props {
  data: ComplexRouteHeaderViewModel
  onGoBack: () => void
  onEditSearch: () => void
}

export const ComplexRouteSearchHeader: FC<Props> = ({
  data,
  onGoBack,
  onEditSearch,
}) => {
  const { passengersLabel, cabinLabel, segments } = data

  return (
    <div className={s.wrapper}>
      <div className={clsx(s.row, 'container')}>
        <button
          type="button"
          className={s.backButton}
          onClick={onGoBack}
        >
          <AppIcon
            width={24}
            height={24}
            id={AllIcons.ARROW_LEFT}
          />
        </button>

        <div className={s.pill}>
          <button
            type="button"
            className={s.pillBody}
            onClick={onEditSearch}
          >
            <div className={s.metaColumn}>
              <span className={s.metaLine}>{`${passengersLabel} •`}</span>
              <span className={s.metaLine}>{cabinLabel}</span>
            </div>

            <div className={s.divider} />

            <div className={s.segmentsScroll}>
              {segments.map((segment, index) => (
                <Fragment
                  key={`${segment.routeLabel}-${segment.dateLabel}-${index}`}
                >
                  {index > 0 ? <div className={s.divider} /> : null}

                  <div className={s.segmentColumn}>
                    <span className={s.dateLabel}>{segment.dateLabel}</span>
                    <span className={s.routeLabel}>{segment.routeLabel}</span>
                  </div>
                </Fragment>
              ))}
            </div>
          </button>

          <button
            type="button"
            className={s.editZone}
            onClick={onEditSearch}
          >
            <AppIcon
              width={18}
              height={18}
              className={s.editIcon}
              id={AllIcons.PENCIL_FILLED}
            />
          </button>
        </div>
      </div>

      <div className={s.bottom} />
    </div>
  )
}
